const body = "'Source Sans Pro', sans-serif";
export const fonts = {
  body,
  heading: body,
  mono: "'Fira Code', monospace",
};
